import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConverterService,
  InterceptorUtil, OccEndpointsService, OCC_USER_ID_ANONYMOUS, USE_CLIENT_TOKEN
} from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomTicketsAdapter } from '../conectors/custom-tickets.adapters';
import { Ticket, TicketWrapper } from '../model/ticket.model';


@Injectable({
  providedIn: 'root',
})
export class CustomOccTicketsAdapter implements CustomTicketsAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {
  }

  loadTicketCategories(): Observable<any> {
    const url = this.occEndpoints.buildUrl('ticketsCategories');
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http.get<any>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((tickets) => {
          return tickets;
        }
        )
      );
  }

  loadTicketCompanyCategories(): Observable<any> {
    const url = this.occEndpoints.buildUrl('ticketsCompanyCategories');
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http.get<any>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((tickets) => {
          return tickets;
        }
        )
      );
  }

  loadTicket(ticketId: string, userId: string): Observable<any> {
    const url = this.occEndpoints.buildUrl('getTicket', { urlParams: { userId, ticketId } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get<any>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((ticket) => {
          return ticket;
        }
        )
      );
  }

  addTicket(supportTicket: Ticket, userId: string): Observable<any> {
    const url = this.occEndpoints.buildUrl('addTicket', { urlParams: { userId } });
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.http.post<Ticket>(url, { ...supportTicket }, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((ticketAdded) => {
          return ticketAdded;
        }
        )
      );
  }

  loadTickets(userId: string, pageSize?: number,
    currentPage?: number,
    sort?: string): Observable<TicketWrapper> {
    let params = new HttpParams().set('sort', sort ? sort : 'CreationDateTime');
    if (pageSize) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (currentPage) {
      params = params.set('currentPage', currentPage.toString());
    }

    const url = this.occEndpoints.buildUrl('tickets', { urlParams: { userId } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get<TicketWrapper>(url, { headers, params })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((tickets) => {
          return tickets;
        }
        )
      );
  }
}

